import { Component } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';

@Component({
  selector: 'app-panel',
  standalone: true,
  imports: [RouterLink, RouterModule],
  templateUrl: './panel.component.html',
 // styleUrls: ['./app.component.scss']
})
export class PanelComponent {
  title = 'Renault Digital frontend';
}
